import axios from 'axios';

const api = process.env.REACT_APP_API_URL;

// Device token lives in sessionStorage only — never localStorage, never persisted across sessions
const getToken = () => sessionStorage.getItem('kioskToken');

const kioskFetch = (method, endpoint, data) =>
  axios({
    method,
    url: `${api}${endpoint}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    },
    data,
  }).then(r => r.data);

export const fetchKioskConfig = () => kioskFetch('GET', 'kiosk/config');

export const submitKioskCheckin = data => kioskFetch('POST', 'kiosk/check-in', data);

// Called once when the kiosk URL is first loaded — stores token for the session
export const initKioskSession = token => {
  sessionStorage.setItem('kioskToken', token);
};

export const hasKioskSession = () => !!getToken();
